import { getLocalStorage, saveLocalStorage } from "@elit-hair/elit-tools";

import { LOCAL_STORAGE_KEYS } from "@/constants/local-storage-keys";
import { isIosDevice } from "@/utils/is-ios-device";

export const getVoiceRegistrationToken = (fcmToken: string | null | undefined): string | null => {
    const trimmedFcmToken = fcmToken?.trim();
    if (trimmedFcmToken) {
        return trimmedFcmToken;
    }

    if (!isIosDevice()) {
        return null;
    }

    const existing = getLocalStorage<string | null>(LOCAL_STORAGE_KEYS.VOICE_REGISTRATION_ID.key, null)?.trim();
    if (existing) {
        return existing;
    }

    const generated = crypto.randomUUID();
    saveLocalStorage(LOCAL_STORAGE_KEYS.VOICE_REGISTRATION_ID.key, generated);
    return generated;
};
